import { Component, OnInit } from '@angular/core';
import { DataSource, DataSourceService, IgoMap, LayerOptions, LayerService, MapBrowserComponent, OSMDataSource, OSMDataSourceOptions, QueryableDataSourceOptions, VectorLayer } from '@igo2/geo';
import { Point } from 'ol/geom';
import { take } from 'rxjs';
import { Feature } from 'ol';
import { NameOfCommentaireLayer } from '../sigt-rapport-commentaire.component';
import { StorageService } from '@igo2/core/storage';
import { LanguageService } from '@igo2/core/language';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import * as olstyle from 'ol/style';
import GeoJSON from 'ol/format/GeoJSON';
import olClusterSource from 'ol/source/Cluster';
import olVectorSource from 'ol/source/Vector';

@Component({
    selector: 'app-fiche-commentaire',
    templateUrl: './fiche-commentaire.component.html',
    styleUrls: ['./fiche-commentaire.component.scss'],
    imports: [
        CommonModule,
        TranslateModule,
        MapBrowserComponent
    ]
})
export class FicheCommentaireComponent implements OnInit {
  public map: IgoMap = new IgoMap({
    view: {
      projection: 'EPSG:4326'
    },
    controls: {
      attribution: {
        collapsed: true
      },
      scaleLine: true
    }
  });
  commentaire: any;
  public defaultStyle: olstyle.Style | ((feature, resolution) => olstyle.Style);
  typePlan: NameOfCommentaireLayer;
  pageTitle: string = '';

  constructor(
    private dataSourceService: DataSourceService,
    private layerService: LayerService,
    private storageService: StorageService,
    private languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.typePlan = this.storageService.get('sigtRapportCommentaireTypePlan') as NameOfCommentaireLayer;
    switch (this.typePlan) {
      case 'CommentairesPlansOfficielsPoints':
        this.pageTitle = this.languageService.translate.instant('sigt.integration.rapportCommentaires.card.typePlanOfficiel');
        break;
      case 'CommentairesPlansTravailPoints':
        this.pageTitle = this.languageService.translate.instant('sigt.integration.rapportCommentaires.card.typePlanTravail');
        break;
      case 'Consultations':
        this.pageTitle = this.languageService.translate.instant('sigt.integration.rapportCommentaires.card.typePlanGeneral');
        break;
    }
    this.createMap();
  }

  createMap() {
    var commentaireFromStore = this.storageService.get('sigtRapportCommentaire');
    if (commentaireFromStore) {
      this.commentaire = JSON.parse(commentaireFromStore.toString());
      this.dataSourceService
        .createAsyncDataSource({
          type: 'osm'
        } satisfies OSMDataSourceOptions)
        .subscribe((dataSource: OSMDataSource) => {
          this.map.layerController.add(
            this.layerService.createLayer({
              title: 'OSM',
              source: dataSource,
              visible: true,
              baseLayer: true
            } satisfies LayerOptions)
          );
        });

      const geoJson = new GeoJSON();
      var point = geoJson.readGeometry({
        type: "Point",
        coordinates: [this.commentaire.longitude, this.commentaire.latitude]
      }) as Point;
      this.map.ol.getView().fit(point.getExtent());
      const olFeature = new Feature({
        geometry: point
      });
      this.tryAddFeaturesToMap([olFeature]);
      // moveToOlFeatures(
      //   this.map.viewController,
      //   [olFeature],
      //   FeatureMotion.Zoom
      // );
      this.map.viewController.zoomTo(15);
    }
  }

  public tryAddFeaturesToMap(features: Feature[]) {
    this.defaultStyle = (_feature, _resolution) => {
      return new olstyle.Style({
        image: new olstyle.Circle({
          radius: 4,
          fill: new olstyle.Fill({
            color: 'rgba(89, 200, 20, 0.8)'
          }),
          stroke: new olstyle.Stroke({
            width: 1,
            color: 'black'
          })
        })
      });
    };

    this.dataSourceService
      .createAsyncDataSource({
        type: 'vector',
        queryable: true
      } as QueryableDataSourceOptions)
      .pipe(take(1))
      .subscribe((dataSource: DataSource) => {
        const olLayer = this.layerService.createLayer({
          isIgoInternalLayer: true,
          title: 'Zone',
          source: dataSource,
          visible: true
        }) as VectorLayer;

        const ol = dataSource.ol as olVectorSource | olClusterSource;
        ol.addFeatures(features);
        olLayer.ol.setStyle(this.defaultStyle);
        this.map.layerController.add(olLayer);
      });
  }

}
